import { createContext } from "react";

export const Contexts = createContext()